import { useRouter } from 'next/router';
import React, { useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
const TrustBox = () => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null);
  let router = useRouter();
  React.useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, [router.asPath]);
  return (
    <div
      ref={ref} // We need a reference to this element to load the TrustBox in the effect.
      className='trustpilot-widget'
      data-locale='en-US'
      data-template-id='5419b637fa0340045cd0c936'
      data-businessunit-id='63dc07581d8f883d27c5513d'
      data-style-height='20px'
      data-style-width='100%'
      data-theme='light'
    >
      <a
        href='https://www.trustpilot.com/review/24hrdoc.com'
        target='_blank'
        rel='noopener noreferrer'
      >
        {' '}
        Trustpilot
      </a>
    </div>
  );
};
export default TrustBox;

export function TrustBoxWide() {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref2 = React.useRef(null);
  const ref3 = React.useRef(null);
  let router = useRouter();
  React.useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref2.current, true);
      window.Trustpilot.loadFromElement(ref3.current, true);
    }
  }, [router.asPath]);
  return (
    <div className='trustBoxes'>
      <div
        ref={ref2}
        className='trustpilot-widget'
        data-locale='en-US'
        data-template-id='53aa8912dec7e10d38f59f36'
        data-businessunit-id='63dc07581d8f883d27c5513d'
        data-style-height='140px'
        data-style-width='100%'
        data-theme='light'
        data-stars='4,5'
        data-review-languages='en'
        data-font-family='Poppins'
      >
        <a
          href='https://www.trustpilot.com/review/24hrdoc.com'
          target='_blank'
          rel='noopener noreferrer'
        >
          <Spinner
            animation='border'
            variant='primary'
            style={{ width: '3rem', height: '3rem', margin: '0 auto' }}
          />
        </a>
      </div>
      <div
        ref={ref3}
        className='trustpilot-widget'
        data-locale='en-US'
        data-template-id='539ad0ffdec7e10e686debd7'
        data-businessunit-id='63dc07581d8f883d27c5513d'
        data-style-height='350px'
        data-style-width='100%'
        data-theme='light'
        data-stars='4,5'
        data-review-languages='en'
        data-font-family='Poppins'
      >
        <a
          href='https://www.trustpilot.com/review/24hrdoc.com'
          target='_blank'
          rel='noopener noreferrer'
        >
          Trustpilot
        </a>
      </div>
    </div>
  );
}
export function TrustBoxFullPage() {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref3 = React.useRef(null);
  let router = useRouter();
  React.useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref3.current, true);
    }
  }, [router.asPath]);
  return (
    <div
      ref={ref3}
      style={{ padding: '0 2.5rem' }}
      className='trustpilot-widget'
      data-locale='en-US'
      data-template-id='539adbd6dec7e10e686debee'
      data-businessunit-id='63dc07581d8f883d27c5513d'
      data-style-height='760px'
      data-style-width='100%'
      data-theme='light'
      data-stars='4,5'
      data-review-languages='en'
    >
      <a
        href='https://www.trustpilot.com/review/24hrdoc.com'
        target='_blank'
        rel='noopener noreferrer'
        style={{
          display: 'flex',
          justifyContent: 'center',
          margin: '4rem 0',
        }}
      >
        <Spinner
          animation='border'
          variant='primary'
          style={{ width: '3rem', height: '3rem', margin: '0 auto' }}
        />
      </a>
    </div>
  );
}
export function TrustBoxFooter() {
  const ref5 = useRef(null);
  const router = useRouter();

  useEffect(() => {
    // Give a slight delay to ensure DOM is updated before loading TrustBox
    const timeout = setTimeout(() => {
      if (window.Trustpilot && ref5.current) {
        window.Trustpilot.loadFromElement(ref5.current, true);
      }
    }, 100); // tweak delay if needed

    return () => clearTimeout(timeout);
  }, [router.asPath]);

  return (
    <div
      ref={ref5}
      className='trustpilot-widget'
      data-locale='en-US'
      data-template-id='5419b6ffb0d04a076446a9af'
      data-businessunit-id='63dc07581d8f883d27c5513d'
      data-style-height='20px'
      data-style-width='100%'
      data-style-background='black'
    >
      <a
        href='https://www.trustpilot.com/review/24hrdoc.com'
        target='_blank'
        rel='noreferrer'
      >
        .
      </a>
    </div>
  );
}
